import React, { useState } from 'react';

import { CardMedia, Link, Typography } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import SecuredImage from 'components/SecuredImage';
import Attachment from 'components/SvgComponents/icons/Attachment';
import Finalcad from 'components/SvgComponents/icons/Finalcad';
import PlanPdf from 'components/SvgComponents/icons/PlanPdf';
import { quality } from 'utils/constants';

const CardMediaImage = ({
  src,
  componentProps,
  materialUIClasses = {},
  type,
  isPdf,
  fileName,
  fileSrc,
  title,
  size,
  component,
  placeholder,
  className,
}) => {
  const [error, setError] = useState(false);

  const handleImageError = () => {
    setError(true);
  };

  const icon = type ? (
    <Attachment color="primary" fontSize="large" />
  ) : (
    <PlanPdf width={size || 16} height={size || 16} />
  );

  if (error) {
    return (
      <div
        className={classNames({
          [materialUIClasses.root]: materialUIClasses.root && !type,
        })}
      >
        {isPdf ? (
          <>
            <div {...componentProps}>{icon}</div>
            <Typography variant="caption" color="textSecondary">
              <Link href={fileSrc || src} component="button">
                {fileName}
              </Link>
            </Typography>
          </>
        ) : (
          <Finalcad {...componentProps} color="inherit" />
        )}
      </div>
    );
  }

  return (
    <div className={className}>
      <SecuredImage placeholder={placeholder} imgQuality={quality.thumbnail} showFallback>
        <CardMedia
          title={title}
          src={src}
          className="cardMediaImage"
          component={component || 'img'}
          onError={handleImageError}
          {...componentProps}
        />
      </SecuredImage>
    </div>
  );
};

CardMediaImage.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  src: PropTypes.string,
  componentProps: PropTypes.object,
  materialUIClasses: PropTypes.object,
  type: PropTypes.string,
  isPdf: PropTypes.bool,
  fileName: PropTypes.string,
  size: PropTypes.number,
  component: PropTypes.string,
  title: PropTypes.string,
  fileSrc: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  sx: PropTypes.object,
};

export default CardMediaImage;
